/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IngestionLogsJsonZipIngestResponseDto,
  IngestionLogsResponseDto,
} from '../models/index';
import {
    IngestionLogsJsonZipIngestResponseDtoFromJSON,
    IngestionLogsJsonZipIngestResponseDtoToJSON,
    IngestionLogsResponseDtoFromJSON,
    IngestionLogsResponseDtoToJSON,
} from '../models/index';

export interface IngestionLogsControllerUploadChunkRequest {
    chunk: Blob;
    uploadId: string;
    chunkIndex: number;
    totalChunks: number;
    originalFileName: string;
    assetId: string;
    clientName: string;
    timestampColumn?: string;
    logColumn?: string;
}

export interface IngestionLogsJsonZipControllerIngestArchiveRequest {
    assetId: string;
    clientName: string;
    archive: Blob;
    batchSize?: number;
}

/**
 * 
 */
export class IngestionLogsApi extends runtime.BaseAPI {

    /**
     * Upload an ingestion log file chunk
     */
    async ingestionLogsControllerUploadChunkRaw(requestParameters: IngestionLogsControllerUploadChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestionLogsResponseDto>> {
        if (requestParameters['chunk'] == null) {
            throw new runtime.RequiredError(
                'chunk',
                'Required parameter "chunk" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        if (requestParameters['uploadId'] == null) {
            throw new runtime.RequiredError(
                'uploadId',
                'Required parameter "uploadId" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        if (requestParameters['chunkIndex'] == null) {
            throw new runtime.RequiredError(
                'chunkIndex',
                'Required parameter "chunkIndex" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        if (requestParameters['totalChunks'] == null) {
            throw new runtime.RequiredError(
                'totalChunks',
                'Required parameter "totalChunks" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        if (requestParameters['originalFileName'] == null) {
            throw new runtime.RequiredError(
                'originalFileName',
                'Required parameter "originalFileName" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        if (requestParameters['clientName'] == null) {
            throw new runtime.RequiredError(
                'clientName',
                'Required parameter "clientName" was null or undefined when calling ingestionLogsControllerUploadChunk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['chunk'] != null) {
            formParams.append('chunk', requestParameters['chunk'] as any);
        }

        if (requestParameters['uploadId'] != null) {
            formParams.append('uploadId', requestParameters['uploadId'] as any);
        }

        if (requestParameters['chunkIndex'] != null) {
            formParams.append('chunkIndex', requestParameters['chunkIndex'] as any);
        }

        if (requestParameters['totalChunks'] != null) {
            formParams.append('totalChunks', requestParameters['totalChunks'] as any);
        }

        if (requestParameters['originalFileName'] != null) {
            formParams.append('originalFileName', requestParameters['originalFileName'] as any);
        }

        if (requestParameters['assetId'] != null) {
            formParams.append('asset_id', requestParameters['assetId'] as any);
        }

        if (requestParameters['clientName'] != null) {
            formParams.append('clientName', requestParameters['clientName'] as any);
        }

        if (requestParameters['timestampColumn'] != null) {
            formParams.append('timestampColumn', requestParameters['timestampColumn'] as any);
        }

        if (requestParameters['logColumn'] != null) {
            formParams.append('logColumn', requestParameters['logColumn'] as any);
        }


        let urlPath = `/api/v1/ingestion-logs/chunks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IngestionLogsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upload an ingestion log file chunk
     */
    async ingestionLogsControllerUploadChunk(requestParameters: IngestionLogsControllerUploadChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestionLogsResponseDto> {
        const response = await this.ingestionLogsControllerUploadChunkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ingest CSV rows mapped on the frontend
     */
    async ingestionLogsControllerUploadMappedCsvRowsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestionLogsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/ingestion-logs/csv-rows`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IngestionLogsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Ingest CSV rows mapped on the frontend
     */
    async ingestionLogsControllerUploadMappedCsvRows(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestionLogsResponseDto> {
        const response = await this.ingestionLogsControllerUploadMappedCsvRowsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Ingest a zip or tar archive that contains nested json or jsonl files
     */
    async ingestionLogsJsonZipControllerIngestArchiveRaw(requestParameters: IngestionLogsJsonZipControllerIngestArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IngestionLogsJsonZipIngestResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling ingestionLogsJsonZipControllerIngestArchive().'
            );
        }

        if (requestParameters['clientName'] == null) {
            throw new runtime.RequiredError(
                'clientName',
                'Required parameter "clientName" was null or undefined when calling ingestionLogsJsonZipControllerIngestArchive().'
            );
        }

        if (requestParameters['archive'] == null) {
            throw new runtime.RequiredError(
                'archive',
                'Required parameter "archive" was null or undefined when calling ingestionLogsJsonZipControllerIngestArchive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['assetId'] != null) {
            formParams.append('assetId', requestParameters['assetId'] as any);
        }

        if (requestParameters['clientName'] != null) {
            formParams.append('clientName', requestParameters['clientName'] as any);
        }

        if (requestParameters['batchSize'] != null) {
            formParams.append('batchSize', requestParameters['batchSize'] as any);
        }

        if (requestParameters['archive'] != null) {
            formParams.append('archive', requestParameters['archive'] as any);
        }


        let urlPath = `/api/v1/ingestion-logs/json-zip/ingest`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IngestionLogsJsonZipIngestResponseDtoFromJSON(jsonValue));
    }

    /**
     * Ingest a zip or tar archive that contains nested json or jsonl files
     */
    async ingestionLogsJsonZipControllerIngestArchive(requestParameters: IngestionLogsJsonZipControllerIngestArchiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IngestionLogsJsonZipIngestResponseDto> {
        const response = await this.ingestionLogsJsonZipControllerIngestArchiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
